import type { Conversation } from '@shared/api/types'

type PinnedConversation = Pick<Conversation, 'id'> & {
  my: Pick<Conversation['my'], 'pinned_order'>
}

type PinnedOrderPatch = {
  conversationId: Conversation['id']
  pinned_order: NonNullable<Conversation['my']['pinned_order']>
}

/** Переставляет закрепление в полном списке, включая скрытые текущим фильтром чаты. */
export function reorderPinnedConversations(
  conversations: readonly PinnedConversation[],
  sourceId: string,
  targetId: string,
): PinnedOrderPatch[] {
  const pinned = conversations
    .flatMap(({ id, my }) => (my.pinned_order == null ? [] : [{ id, pinned_order: my.pinned_order }]))
    .sort((a, b) => a.pinned_order - b.pinned_order || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))
  const from = pinned.findIndex((item) => item.id === sourceId)
  const to = pinned.findIndex((item) => item.id === targetId)
  if (from < 0 || to < 0 || from === to) return []

  // Сохраняем индекс цели до извлечения, как в существующем drag-and-drop.
  const [moved] = pinned.splice(from, 1)
  if (!moved) return []
  pinned.splice(to, 0, moved)
  return pinned.flatMap((item, index) =>
    item.pinned_order === index ? [] : [{ conversationId: item.id, pinned_order: index }],
  )
}
